export default __webpack_public_path__ + "static/hero-tutoring-071ff476efda9d679d882cf59abde3c4.jpg";